import { render, staticRenderFns } from "./LimitTransactionAgree.vue?vue&type=template&id=5179c807&scoped=true&"
import script from "./LimitTransactionAgree.vue?vue&type=script&lang=js&"
export * from "./LimitTransactionAgree.vue?vue&type=script&lang=js&"
import style0 from "./LimitTransactionAgree.vue?vue&type=style&index=0&id=5179c807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179c807",
  null
  
)

export default component.exports